// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"Checkbox_checkbox__sh3js","colorBoxWithLabel":"Checkbox_colorBoxWithLabel__3LQOZ"};